import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
       'lastName', 
      'namePublic',
      'team.name',
      'team.category.label',
    ];

    const exportDefinitions = [
      { value: 'id', label: 'Id' },
      { value: 'name', label: 'Name' },
      { value: 'lastName', label: 'LastName' },
      { value: 'dni', label: 'DNI/NIE/PASAPORTE' },
      { value: 'email', label: 'Email' },
      { value: 'dorsal', label: 'Dorsal' },
      { value: 'created', label: 'Created at' },
      { value: 'modified', label: 'Updated at' }
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-pager.js